import React from "react";
import Body from "./Body";

const DigitalPresence = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default DigitalPresence;
